import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsICAgreementRedesignedUIEnabled() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_IC_AGREEMENT_REDESIGNED_UI, {
    defaultValue: {
      signAgreement: false,
      viewAgreement: false,
    },
  });
}
